const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
const CARTO_ATTRIBUTION = `${OSM_ATTRIBUTION} &copy; <a href="https://carto.com/attributions">CARTO</a>`;

function cartoApiKey() {
    const meta = document.querySelector('meta[name="carto-basemap-api-key"]');
    return meta ? meta.content.trim() : '';
}

function cartoTileUrl(cartoStyle) {
    const key = cartoApiKey();
    const url = `https://{s}.basemaps.cartocdn.com/${cartoStyle}/{z}/{x}/{y}{r}.png`;

    return key ? `${url}?key=${encodeURIComponent(key)}` : url;
}

export function baseMapConfig(cartoStyle) {
    return {
        url: cartoTileUrl(cartoStyle),
        attribution: CARTO_ATTRIBUTION,
        subdomains: 'abcd'
    };
}

export function satelliteLabelsConfig() {
    return {
        url: cartoTileUrl('dark_only_labels'),
        attribution: CARTO_ATTRIBUTION,
        subdomains: 'abcd'
    };
}
